import { Dialog } from "@headlessui/react";

import Button from "../../atoms/button";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import LoadingButton from "../../../pages/authoring-dashboard/learning-path-library/statusModal/loadingButton";
import { useState } from "react";
import { UtilitySpeakers } from "../../../pages/session-preview/speakers";
import StakeHolderDisplay from "@lxp-app/pages/preview-event/stakeholderDetail";
import { ActionButtonSlice } from "@lxp-app/components/atoms/content-authoring-tabular/actionButtonSlice";
import { useDispatch } from "react-redux";
import { useAuthoringLibraryLanguage } from "../../../utils/authoringLibraryResources/useAuthoringLibraryLanguage";
import { getAuthoringLibraryLabel } from "../../../utils/authoringLibraryResources/localizeAuthoringLibraryLabels";
interface DialogProps {
  message?: string;
  isShow: boolean;
  show: () => void;
  setOpen: (val: boolean) => void;
  onDelete?: (reamrk: string) => void;
  setStatusRemarks?: (val: string) => void;
  buttonName: string;
  heading: string;
  data?: any;
  viewAttendance?: boolean;
  isLoading?: boolean;
  loadingLabel?: string;
  msg?: string;
  showRemarksDeleteModal?: boolean;
  title?: string;
  showTitle?: boolean;
  contentType?: "user group" | "content" | "course";
  comments?: any;
  isMsgRequired?: boolean;
  commentsAllowed?: boolean;
  onClose?: () => void;
}

const ContentDeleteModal = ({
  message,
  isShow,
  show,
  onDelete,
  isMsgRequired = false,
  buttonName,
  setOpen,
  heading,
  data,
  viewAttendance,
  isLoading,
  loadingLabel,
  msg,
  setStatusRemarks,
  showRemarksDeleteModal = true,
  title,
  contentType,
  comments,
  onClose,
  showTitle = true,
  commentsAllowed = true
}: DialogProps) => {
  //   const [open, setOpen] = useState(isShow);
  const dispatch = useDispatch();
  const [remarks, setRemarks] = useState("");
  const user = useSelector((state: RootState) => state.UserInfoSlice);
  const { language } = useAuthoringLibraryLanguage(
    user.profile?.preferences?.language
  );
  //   useEffect(() => {
  //     setOpen(open);
  //   }, [isShow, open]);

  const closeModal = () => {
    if (onClose) onClose();
    setOpen(false);
  };
  const btnClick = () => {
    setOpen(false);
    show();
  };

  function handleRemarks(comments: string) {
    setRemarks(comments);
    dispatch(
      ActionButtonSlice.actions.setStatus({
        setRemarks: comments.trimStart()
      })
    );
    if (setStatusRemarks) setStatusRemarks(comments);
  }

  return (
    <>
      {showRemarksDeleteModal ? (
        <div className=" w-full ">
          <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
            <div className="font-bold text-primary mb-5">
              <Dialog.Title
                as="h3"
                className="text-lg font-semibold leading-6 text-gray-900 dark:text-gray-50"
              >
                {heading}
              </Dialog.Title>
              {!isMsgRequired &&
                (msg && msg?.length > 0 ? (
                  <div className="my-4 text-base">{msg}</div>
                ) : (
                  <div className="my-4 text-base">
                    {title
                      ? getAuthoringLibraryLabel(
                          "deleteContentWithTitlePrompt",
                          language
                        )
                          .replace(
                            "{{contentType}}",
                            contentType ||
                              getAuthoringLibraryLabel("content", language)
                          )
                          .replace("{{title}}", title)
                      : getAuthoringLibraryLabel(
                          "deleteContentPrompt",
                          language
                        ).replace(
                          "{{contentType}}",
                          contentType ||
                            getAuthoringLibraryLabel("content", language)
                        )}
                  </div>
                ))}
            </div>
            {comments?.length > 0 && (
              <div
                className={`mb-5 overflow-auto p-1 ${
                  comments?.length <= 3 ? "h-auto" : "h-32"
                }`}
              >
                {comments?.map((comment: any) => {
                  return comment.remarks ? (
                    <div key={comment.id} className="pt-2  pb-5">
                      <StakeHolderDisplay
                        users={[comment.createdby]}
                        data-testid="stakeholderCompOnStatusModal"
                      />
                      {comment.remarks}
                    </div>
                  ) : null;
                })}
              </div>
            )}
            {commentsAllowed && (
              <div className="flex space-x-2">
                <UtilitySpeakers ids={[user.profile.id]} view="circular" />
                <form action="#" className="relative flex-auto">
                  <div className="w-full overflow-hidden rounded-lg pb-2 shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-primary">
                    <label htmlFor="comment" className="sr-only">
                      {getAuthoringLibraryLabel("addYourComment", language)}
                    </label>
                    <textarea
                      rows={2}
                      name="comment"
                      id="comment"
                      className="block w-full resize-none border-0 bg-transparent py-1.5 text-gray-900  placeholder:text-gray-400  dark:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                      placeholder={`${getAuthoringLibraryLabel("addYourComment", language)}...`}
                      defaultValue={""}
                      maxLength={200}
                      onChange={(e) =>
                        handleRemarks(e.target.value.trimStart())
                      }
                    />
                  </div>
                  {remarks.length == 200 ? (
                    <span className="text-gray-400 text-xs m-1  grid justify-end">
                      {getAuthoringLibraryLabel("maxLimitReached", language)}
                    </span>
                  ) : (
                    <span className="text-gray-400 text-xs m-1 grid justify-end">
                      {" "}
                      {remarks.length}/{200}
                    </span>
                  )}
                </form>
                <div className="text-red-600 text-xl">*</div>
              </div>
            )}
            <div className="mt-5 sm:mt-4 mr-2 flex justify-end space-x-2 md:mb-3 mb-5">
              {isLoading ? (
                <LoadingButton loadingLabel={loadingLabel} />
              ) : (
                <Button
                  label={buttonName}
                  variant="contained"
                  buttonColor="primary"
                  onClick={btnClick}
                  testId={`${buttonName?.replace(/\s/g, "")}btn`}
                  disable={
                    !(remarks && remarks.trim().length > 0) && commentsAllowed
                  }
                />
              )}
              {/* 
    <div className="mr-2">
      {" "}
      <Button
        label="Close"
        variant="outlined"
        buttonColor="secondary"
        onClick={closeModal}
        testId="closeModalBtn"
      />
    </div> */}
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full">
          <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
            <Dialog.Title
              as="h3"
              className="text-lg font-semibold leading-6 text-gray-900 dark:text-gray-50"
            >
              {heading}
            </Dialog.Title>
            {!isMsgRequired &&
              (msg && msg?.length > 0 ? (
                <div className="my-4 text-base">{msg}</div>
              ) : (
                <div className="my-4 text-base">
                  {showTitle
                    ? getAuthoringLibraryLabel(
                        "deleteContentWithTitlePrompt",
                        language
                      )
                        .replace("{{contentType}}", contentType || "content")
                        .replace(
                          "{{title}}",
                          title
                            ? title
                            : getAuthoringLibraryLabel("untitled", language)
                        )
                    : getAuthoringLibraryLabel(
                        "deleteContentPrompt",
                        language
                      ).replace("{{contentType}}", contentType || "content")}
                </div>
              ))}
          </div>
          <div className="mt-5 sm:mt-4 mr-2 flex justify-end space-x-2 md:mb-3 mb-5">
            {isLoading ? (
              <LoadingButton loadingLabel={loadingLabel} />
            ) : (
              <Button
                label={buttonName}
                variant="contained"
                buttonColor="primary"
                onClick={btnClick}
                testId={buttonName?.replace(/\s/g, "") + "btn"}
              />
            )}
            <div className="mr-2">
              <Button
                label={getAuthoringLibraryLabel("close", language)}
                variant="outlined"
                buttonColor="secondary"
                onClick={closeModal}
                testId="closeModalBtn"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ContentDeleteModal;
